import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { message } from "antd";
import { getProjectsListV2 } from "../../api";

const useFetchProjects = (isCommercialDashboard, isPartnerships, isGCCProject, isFemtechAnalyticsProject, isEcosystemProject, isPartnershipsSandbox, isBizdevSandbox) => {
  // Temporarily we passing params this way.
  const [querySearch, setQuerySearch] = useState("");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const sectorName = useSelector((state) => state.notificationsData.sectorName);

  useEffect(() => {
    setProjects([]);
    setPage(1);
  }, [sectorName]);

  useEffect(() => {
    let debounceTimeout;

    if (querySearch) {
      // If query search then delay the API call until the user finishes
      debounceTimeout = setTimeout(() => {
        loadProjects(1, querySearch);
      }, 2000);
    } else {
      loadProjects(page, querySearch); // Called after sector name change
    }

    // Cleanup function to clear the timeout
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [querySearch, sectorName, page]);

  const loadProjects = (page, querySearch) => {
    setLoading(true);

    // Construct the query object
    const query = {
      page,
      querySearch,
      isCommercialDashboard,
      isPartnerships,
      isGCCProject,
      isFemtechAnalyticsProject,
      isEcosystemProject,
      isPartnershipsSandbox,
      isBizdevSandbox,
      sector: sectorName,
      platform: window.location.origin,
    };

    getProjectsListV2(query)
      .then(({ data }) => {
        if (data?.projects?.docs) {
          const newProjects = data?.projects?.docs;
          setProjects((prev) => {
            return [...new Set([...prev, ...newProjects])];
          });
          setHasMore(data?.projects?.hasNextPage);
        } else {
          setHasMore(false);
        }
      })
      .catch(() => {
        message.error("Something went wrong, Please try again !!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const memoizedProjects = useMemo(() => projects, [projects, querySearch, sectorName]);

  const searchFilter = (e) => {
    setProjects([]);
    setQuerySearch(e.target.value);
    setPage(1);
  };

  const fetchMoreData = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return {
    projects,
    loading,
    hasMore,
    searchFilter,
    fetchMoreData,
    querySearch
  };
};

export default useFetchProjects;
